import { flattenValues } from "@uniformdev/canvas";

import { ValuePropCardData } from "@/libraries/design/patterns/value-props/src/value-prop-card";
import ValueProps, {
    MediaAspectRatio
} from "@/libraries/design/patterns/value-props/src/value-props";

interface UniformValuePropsProps {
    title: string;
    subtitle?: string;
    cards: ValuePropCardData[];
    mediaAspectRatio?: MediaAspectRatio;
}

const UniformValueProps = ({
    title,
    subtitle,
    cards,
    mediaAspectRatio
}: UniformValuePropsProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = flattenValues(cards as any) as ValuePropCardData[];

    return (
        <ValueProps
            title={title}
            subtitle={subtitle}
            cards={flattenedCards}
            mediaAspectRatio={mediaAspectRatio}
        />
    );
};

export default UniformValueProps;
